import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=6ddb7b1c&scoped=true&lang=html&"
import script from "./Home.vue?vue&type=script&lang=coffee&"
export * from "./Home.vue?vue&type=script&lang=coffee&"
import style0 from "./Home.vue?vue&type=style&index=0&id=6ddb7b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddb7b1c",
  null
  
)

component.options.__file = "Home.vue"
export default component.exports